import styled from 'styled-components';
import { DatePicker as AntdDatePicker } from 'antd';
import { TextField } from '@material-ui/core';
import { Tune } from '@material-ui/icons';
import { ReactComponent as GroupsSvg } from './icons/groups.svg';

const DatePickerStyled = styled(AntdDatePicker)`
  border: 1px solid #efefef;
  width: 100%;
  input {
    /* Had to remove input border inside datepicker otherwise it looks very odd */
    border: none;
  }
`;

export const TextFieldStyled = styled(TextField)`
  > .MuiInputBase-root {
    border: ${props => props.error && '1px solid red'};
    border-radius: 2px;
    color: ${props => props.error && 'red !important'};
  }
`;

export const PreferencesHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 0 10px;
  margin-bottom: 8px;
  font-family: 'Poppins', sans-serif;
  border-bottom: 1px solid #eef0f3;
`;

export const PreferencesIcon = styled(Tune)`
  color: #3478d7 !important;
  font-size: 24px !important;
`;

export const PreferencesTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const GroupsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 10px;
  margin-bottom: 8px;
  font-family: 'Poppins', sans-serif;
  border-bottom: 1px solid #eef0f3;
`;

export const GroupsTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const GroupsIcon = styled(GroupsSvg)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  path {
    fill: #3478d7;
  }
`;

export default DatePickerStyled;
